import CatalogsPop from './CatalogsPop';
import CatalogsPopIndex from './CatalogsPopIndex';
import GroupSitesPop from './GroupSitesPop';
import MemberCenterPop from './MemberCenterPop';
import MerchantServicePop from './MerchantServicePop';
import MobileIntroPop from './MobileIntroPop';
import MroCatalogsPop from './MroCatalogsPop';
import PlusInfoPop from './PlusInfoPop';
import SearchHistoryListPop from './SearchHistoryListPop';
import SearchListPop from './SearchListPop';
import SeoCatalogsContent from './SeoCatalogsContent';
import ServiceCenterPop from './ServiceCenterPop';
import ShopCarPop from './ShopCarPop';

export {
  MobileIntroPop, // 移动端介绍
  MemberCenterPop, // 会员中心
  ServiceCenterPop, // 联系客服
  GroupSitesPop, //集团网站
  PlusInfoPop, // PLUS会员信息
  ShopCarPop, // 购物车
  SearchHistoryListPop, // 搜索记录 + 热门推荐
  SearchListPop, // 搜索联想词
  CatalogsPop, // 类目
  MerchantServicePop, // 商家服务
  MroCatalogsPop, // Mro 类目
  CatalogsPopIndex, // Mro 类目
  SeoCatalogsContent, // SEO专用类目，可爬，但不影响页面渲染
};
